import moment from 'moment';

import { API_NAME, INVITATION_STATUS, REDUX_STORE } from '@funnels/constants';
import { InvitationActionTypes, InvitationsReducerState, SharedActionTypes, StoreInvitation } from '@funnels/types';

const initialState: InvitationsReducerState = {
  data: [],
  error: null,
  loading: 0,
  cancellation: 0,
};

export default function assetsReducer(
  state: InvitationsReducerState = initialState,
  action: InvitationActionTypes | SharedActionTypes
): InvitationsReducerState {
  switch (action.type) {
    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_DATA:
      return {
        ...state,
        data: [],
      };
    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_ERROR:
    case REDUX_STORE.INVITATIONS.ACTION_TYPES.CLEAR_INVITATION_ERROR:
      return {
        ...state,
        error: null,
      };
    case REDUX_STORE.INVITATIONS.ACTION_TYPES.FETCH_INVITATIONS:
      return {
        ...state,
        data: [],
        loading: state.loading + 1,
      };
    case REDUX_STORE.INVITATIONS.ACTION_TYPES.FETCH_INVITATIONS_SUCCESS:
      return {
        ...state,
        data: action.data.map((invitation) => ({ ...invitation, clientId: invitation.id })),
        loading: state.loading - 1,
      };
    case REDUX_STORE.INVITATIONS.ACTION_TYPES.CREATE_INVITATION:
      return {
        ...state,
        data: [...state.data, action.invitation],
        loading: state.loading + 1,
      };
    case REDUX_STORE.INVITATIONS.ACTION_TYPES.CANCEL_INVITATION:
      return {
        ...state,
        data: state.data.map((invitation) => {
          if (invitation.id === action.invitationId) {
            return { ...invitation, status: INVITATION_STATUS.CANCELLED, isValid: false };
          }

          return invitation;
        }),
        cancellation: state.cancellation + 1,
        loading: state.loading + 1,
      };
    case REDUX_STORE.INVITATIONS.ACTION_TYPES.SET_INVITATION_ERROR:
      // TODO: FUNNEL-1606 - use same pattern in employment reducer, setting error message in same action as fail/abort
      return {
        ...state,
        error: {
          name: API_NAME.INVITATIONS,
          message: action.message,
        },
      };
    case REDUX_STORE.INVITATIONS.ACTION_TYPES.CREATE_INVITATION_SUCCESS:
      const { clientId, serverId } = action;

      return {
        ...state,
        data: state.data.map((invitation: StoreInvitation) =>
          invitation.clientId === clientId
            ? {
                ...invitation,
                id: serverId,
                // expiresOn is needed for 'getLatestInvitation'
                expiresOn: moment().add(5, 'days').toISOString(),
              }
            : invitation
        ),
        loading: state.loading - 1,
      };
    case REDUX_STORE.INVITATIONS.ACTION_TYPES.FETCH_INVITATIONS_FAIL:
    case REDUX_STORE.INVITATIONS.ACTION_TYPES.CREATE_INVITATION_FAIL:
      return {
        ...state,
        loading: state.loading - 1,
      };
    case REDUX_STORE.INVITATIONS.ACTION_TYPES.CANCEL_INVITATION_SUCCESS:
    case REDUX_STORE.INVITATIONS.ACTION_TYPES.CANCEL_INVITATION_FAIL:
      return {
        ...state,
        loading: state.loading - 1,
        cancellation: state.cancellation - 1,
      };
    default:
      return state;
  }
}
